// @flow
import type { Dispatch } from "redux"

import { saveReservationForm } from "../persistStoreTools"
import type { State } from "booking/services/types"
import { reservationFormValuesSelector } from "../selectors/reservationSelectors"
import saveAddedAncillaries from "./saveAddedAncillaries"

const saveReservationFormAction = () => (dispatch: Dispatch<any>, getState: () => State) => {
  const store = getState()
  const reservationFormValues = reservationFormValuesSelector(store)
  if (reservationFormValues) {
    // Do not store payment data
    delete reservationFormValues.payment
    //  TODO: remove baggage field?

    saveReservationForm(reservationFormValues)

    dispatch(saveAddedAncillaries())
  }
}

export default saveReservationFormAction
